import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';
import { FaChevronUp } from 'react-icons/fa';

const ScrollToTop = ({
    text = "חזרה למעלה",
    threshold = 300,
    position = "left",
    className = ""
}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsVisible(scrollTop > threshold);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [threshold]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <button
            onClick={scrollToTop}
            className={`scroll-to-top ${isVisible ? 'visible' : ''} ${position} ${className}`}
            title={text}
        >
            <FaChevronUp className="scroll-icon" />
            <span>{text}</span>
        </button>
    );
};

export default ScrollToTop; 